import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  NavigationExtras
} from "@angular/router";
import { PartnerService } from "../share/service/partner.service";

@Injectable({
  providedIn: "root"
})
export class AffiliatesGuard implements CanActivate {
  constructor(private router: Router, private partnerService: PartnerService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const paramsPartnerCode = route.queryParams.partnerCode;
    const partnerCode = await this.partnerService.getPartnerCode();

    // If no partner anywhere, allow
    if (!paramsPartnerCode && !partnerCode) return true;

    // Prevent infinite loop
    if (
      state.url.startsWith("/affiliates") &&
      paramsPartnerCode === partnerCode
    )
      return true;

    // Detect hostname/subdomain
    const hostname = window.location.hostname.toLowerCase();
    const subdomain = "";

    // ❌ If URL has no partnerCode AND hostname already uniquely identifies partner → skip redirect
    const shouldSkipQueryParam =
      subdomain === partnerCode?.toLowerCase() && !paramsPartnerCode;

    if (shouldSkipQueryParam) {
      return true; // allow, do NOT add query param
    }

    // Otherwise perform redirect ONCE with correct partner param
    // const queryParams = { partnerCode: paramsPartnerCode ?? partnerCode };

    await this.router.navigate(["/affiliates"]);

    return false;
  }
}
